import PropTypes from 'prop-types';
import React from 'react';
import Modal from '../../../../common/Modal';
import Tabs from '../../../../admin/shops/components/ShopListTabs';
import ChairRentalDetails from '../containers/ChairRentalDetails';
import ChairRentalHistory from '../containers/ChairRentalHistory';
import { chairRentalShape } from '../shapes';
import { t } from '../../../../../modules/infra/i18n';

const ChairRentalModal = ({ chairRental, closeModal, toggleEnabled, enabled, setActiveTab }) => (
  <Modal
    close={closeModal}
    showCloseButton
    showSwitcher
    barberName={`${chairRental.barber.firstName} ${chairRental.barber.lastName}`}
    checked={enabled}
    onChange={toggleEnabled}
    switcherId={`chair-rental-toggle-${chairRental.barberId}`}
  >
    <div className="c-chair-rental-modal">
      <Tabs onTabChange={setActiveTab}>
        <div label={t('barber:chair_rental.modal.tab_details')}>
          <ChairRentalDetails chairRental={chairRental} ownerId={chairRental.barberId} ownerType="barber" />
        </div>
        <div label={t('barber:chair_rental.modal.tab_history')}>
          <ChairRentalHistory chairRental={chairRental} />
        </div>
      </Tabs>
    </div>
  </Modal>
);

ChairRentalModal.propTypes = {
  chairRental: chairRentalShape.isRequired,
  closeModal: PropTypes.func.isRequired,
  toggleEnabled: PropTypes.func.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  enabled: PropTypes.bool,
};

ChairRentalModal.defaultProps = {
  enabled: false,
};

export default ChairRentalModal;
